import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Avatar from '../../../base/avatar/components/Avatar';
import SubtitleMessage from './SubtitleMessage';
const useStyles = makeStyles()(theme => {
    return {
        groupContainer: {
            display: 'flex',
            marginBottom: theme.spacing(3)
        },
        avatar: {
            marginRight: theme.spacing(2),
            alignSelf: 'flex-start'
        },
        messagesContainer: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            maxWidth: 'calc(100% - 56px)', // 40px avatar + 16px margin
            gap: theme.spacing(1)
        }
    };
});
/**
 * Component that renders a group of subtitle messages from the same sender.
 *
 * @param {IProps} props - The props for the component.
 * @returns {JSX.Element} - A React component rendering a group of subtitles.
 */
export function SubtitlesGroup({ messages, senderId }) {
    const { classes } = useStyles();
    if (!messages.length) {
        return null;
    }
    return (React.createElement("div", { className: classes.groupContainer },
        React.createElement(Avatar, { className: classes.avatar, participantId: senderId, size: 32 }),
        React.createElement("div", { className: classes.messagesContainer }, messages.map((message, index) => (React.createElement(SubtitleMessage, { key: `${message.timestamp}-${message.id}`, showDisplayName: index === 0, ...message }))))));
}
